<template>
<div v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
  <div class="d-flex" v-if="!flDetails">
    <div class="col-md-3">
      <formPrice v-on:SearchItems="GetFilter"></formPrice>
    </div>
    <div class="col-md-9">
      <div>
        <tablePrice ref="tablePrice" v-on:edit="edit" v-on:deleteEnterprise="deleteEnterprise"></tablePrice>
      </div>
    </div>
  </div>
    <detailsPrice :selectedEnterprise="selectedEnterprise" v-if="flDetails"></detailsPrice>
</div>

</template>

<script>

import pricetablemanagement from '@/views/private/realestate/pricetablemanagement/pricetablemanagement'
export default pricetablemanagement

</script>

<style scoped>
#form-seacch{
  display: flex;
  flex-direction: column;
  align-content: center;
}

.periodos{
 display: flex;
 flex-wrap: wrap;
 justify-content: space-around;

}

.arrow-angel{
  padding-top: 10px;
  font-size: 30px;
  color: black;
  padding-right: 24px;
}

.acording{
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  background-color: #ECEFF1;
  border-radius: 0px;
  height: 50px;
  width: 100%;
}
.mes{
  font-size: 22px;
  color: black;
  padding-top: 16px;
  font-weight: bold;
}

.footer{
  margin-bottom: 10%;
}

.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

.btn-periodos-active{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

.labelseach{
  margin-bottom: 3px;
  font-size: 14px;
  font-weight: bold;
}

#card-sales{
  height: 100%;
  width: 100%;
  padding: 15px;
  border: 1px solid rgb(180, 180, 180);
  background-color: white;
}
#img-card-sales{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#img-card{
  height: 300px;
  width: 300px;
  object-fit: contain;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/pricetablemanagement/pricetablemanagement.vue